var map = {
	"./SL/between-heaven-and-earth.json": "4d4d",
	"./SL/make-your-own-law.json": "c072",
	"./SL/puzzling-poetry-treasure-chest.json": "1f3e",
	"./SL/thinking-outside-the-box.json": "2b38",
	"./colonial-heritage-a-speculation.json": "bb73",
	"./light-type.json": "e91d",
	"./nasal-guard.json": "6547",
	"./remediated-illusion.json": "fc16",
	"./synagoge-soundwalk.json": "c28a",
	"./the-combine.json": "3c67",
	"./thumbs-against-missing-out.json": "f959",
	"./tile-tessellation.json": "7b64",
	"./time-to-breath.json": "c9bb",
	"./vroeg.json": "bdb6",
	"./wemessage.json": "c00e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3bdb";